
<mat-horizontal-stepper
  [linear]="true"
  #stepper
  *ngIf="hasContratos"
>
  <mat-step
    [stepControl]="formGroupContratos"
    [editable]="!hasCompleted"
  >
    <form [formGroup]="formGroupContratos">
      <ng-template matStepLabel>Contrato</ng-template>
      <app-contracts
        [contratos]="contratos"
        (emitContratoSelecionado)="setContratoSelecionado($event)"
      ></app-contracts>
    </form>
  </mat-step>
  <mat-step
    [stepControl]="secondFormGroup"
    [editable]="!hasCompleted"
  >
    <form [formGroup]="secondFormGroup">
      <ng-template matStepLabel>Parcela</ng-template>
      <app-parcelas
        [isMobile]="isMobile"
        [contratoSelecionado]="contratoSelecionado"
        (parcelaSelecionada)="setParcelaSelecionada($event)"
      ></app-parcelas>
    </form>
  </mat-step>
  <mat-step [editable]="false" [completed]="hasCompleted">
    <ng-template matStepLabel>2ºVia</ng-template>
    <app-segunda-via [dadosSegundaVia]="dadosSegundaVia" [showAlert]="showAlertBoleto" (resetEvent)="resetAll()"></app-segunda-via>
  </mat-step>
</mat-horizontal-stepper>

<div fxLayout="column" class="no-have" *ngIf="noHasContratos">
  <div fxFlex>
    <div fxLayoutAlign="center">
      <div
        class="emotion"
      ></div>
    </div>
    <h2>Opa!</h2>
    <p>Parece que você não tem contratos ou seus contratos estão todos quitados!</p>
  </div>
</div>

